// Shared Google Maps configuration
// Use this in all components that need Google Maps

export const GOOGLE_MAPS_LIBRARIES = ['places'];

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const GOOGLE_MAPS_OPTIONS = {
  disableDefaultUI: false,
  zoomControl: true,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: true,
  gestureHandling: 'greedy',
  scrollwheel: true,
  isFractionalZoomEnabled: true,
  styles: [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    }
  ]
};

// TIA Terminal coordinates
export const AIRPORT_TERMINAL = { lat: 41.4186524, lng: 19.7134978 };

// Car marker SVG for vehicles on map
export const CAR_MARKER_SVG = {
  path: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z',
  fillOpacity: 1,
  strokeWeight: 1,
  strokeColor: '#ffffff',
  scale: 1.5,
  anchor: { x: 12, y: 12 }
};

// Get car marker with specific color based on status
export const getCarMarkerOptions = (status) => {
  const colors = {
    online: '#22c55e',    // Green
    available: '#22c55e', // Green
    busy: '#f59e0b',      // Yellow/Orange
    in_ride: '#f59e0b',   // Yellow/Orange
    break: '#f97316',     // Orange
    offline: '#9ca3af'    // Gray
  };
  
  return {
    ...CAR_MARKER_SVG,
    fillColor: colors[status] || colors.offline
  };
};
